import { render, staticRenderFns } from "./MRCompetitors.vue?vue&type=template&id=0b2558f8"
import script from "./MRCompetitors.vue?vue&type=script&lang=js"
export * from "./MRCompetitors.vue?vue&type=script&lang=js"
import style0 from "./MRCompetitors.vue?vue&type=style&index=0&id=0b2558f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports